import { render, staticRenderFns } from "./ResultsAM.vue?vue&type=template&id=5d862277&"
import script from "./ResultsAM.vue?vue&type=script&lang=js&"
export * from "./ResultsAM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports